const baseKey = '/v1/crypto/withdraw'

export const cryptoWithdrawsAPI = {
  baseKey,
  list: `${baseKey}/list`,
  item: (id: string) => `${baseKey}/${id}`,
  create: baseKey,
}
